import { useState } from "react";
import "./FileMetaHandler.scss";
import {
  DefaultButton,
  IconButton,
  MessageBar,
  MessageBarType,
} from "@fluentui/react";
import { ToastMessage } from "../../Utils/UIMessages";

export interface IFileMetaData {
  fileName: string;
  fileData: string;
  fileSize: number;
  updatedDt: string;
}

export interface IFileMetaHandlerProps {
  rawFiles: IFileMetaData[];
  emitFiles: (stringedFiles: IFileMetaData[]) => void;
}

const humanFileSize = (bytes: number, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

const FileMetaHandler = (props: IFileMetaHandlerProps) => {
  return (
    <div>
      <h2>Documenti</h2>
      {props.rawFiles.length === 0 && (
        <MessageBar messageBarType={MessageBarType.info}>
          Non ci sono documenti per questa scheda ospite
        </MessageBar>
      )}
      <div className="buttons-on-right">
        <div></div>
        <DefaultButton
          iconProps={{ iconName: "Upload" }}
          text="Carica"
          onClick={() => {
            document.getElementById("uploader")?.click();
          }}
        />
      </div>
      <input
        type="file"
        hidden
        id="uploader"
        onChange={(e: any) => {
          let file: File = e.target.files[0];

          // Check if file size is greater than 2MB
          if (file.size > 2 * 1024 * 1024) {
            ToastMessage(
              "warning",
              "Il file non può essere più grande di 2Mb."
            );
            return;
          }

          getBase64(file).then((base64) => {
            let newFiles: IFileMetaData[] = [
              ...props.rawFiles,
              {
                fileName: file.name,
                updatedDt: new Date().toISOString(),
                fileData: base64 as string,
                fileSize: file.size,
              },
            ];
            props.emitFiles(newFiles);
          });
        }}
      />
      {props.rawFiles.length > 0 && (
        <table className="full-table">
          <thead>
            <tr>
              <th>Nome File</th>
              <th>Dimensione</th>
              <th>Tipo file</th>
              <th>Caricato il</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.rawFiles.map((x: IFileMetaData, i: number) => {
              return (
                <tr key={i}>
                  <td>{x.fileName}</td>
                  <td>{humanFileSize(x.fileSize, true)}</td>
                  <td>{x.fileName.split(".").pop()?.toUpperCase()}</td>
                  <td>{new Date(x.updatedDt).toLocaleDateString()}</td>
                  <td>
                    <IconButton
                      iconProps={{ iconName: "Download" }}
                      onClick={() => {
                        var base64String = x.fileData;
                        const downloadLink = document.createElement("a");
                        downloadLink.href = base64String;
                        downloadLink.download = x.fileName;
                        downloadLink.click();
                      }}
                    />
                    <IconButton
                      iconProps={{ iconName: "Trash" }}
                      onClick={() => {
                        props.emitFiles(
                          props.rawFiles.filter(
                            (x: IFileMetaData, j: number) => j != i
                          )
                        );
                      }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FileMetaHandler;
